import { cs } from '@/common/service/ApiList';
import { updateToast, insertToast, removeToast } from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';

const { getList, detail, save } = cs;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_DETAIL: async ({ commit, state }, { storeNo, userNo }) => {
    const { status, data } = await ServiceExec.get(detail(storeNo, userNo));
    if (status === 200) commit('setDetail', data);

    commit('setDetail', data);
  },
  SAVE: async ({ commit, state }, form) => {
    const { status, data } = await ServiceExec.post(save, form);
    if (await updateToast(status, data)) return true;
    else return false;
  }
};
export default actions;
